import { cEl, removeToken } from '../../../../util';
import { InputGroupWithErrMsg } from '../../Contact/ContactForm';
import { logout, resetPassword } from '../../../../api/admin';
import { navigateTo } from '../../../AppHeader/Link';
import { PATH_ADMIN_LOGIN } from '../../../path';

function ChangePassword() {
    const managementContainer = cEl('div');
    managementContainer.classList.add('change-password-container');

    const titleContainer = cEl('div');
    titleContainer.classList.add('title-container');

    const titleEl = cEl('div');
    titleEl.classList.add('title');
    titleEl.innerHTML = '관리자 비밀번호 수정';

    const subTitleEl = cEl('div');
    subTitleEl.classList.add('sub-title');
    subTitleEl.innerHTML = 'Admin Setting';

    titleContainer.append(subTitleEl, titleEl);

    const formContainer = cEl('form');
    formContainer.classList.add('form-container');

    const submitWrapper = cEl('div');
    submitWrapper.classList.add('submit-wrapper');

    const submitButton = cEl('button');
    submitButton.classList.add('button', 'brand-button');
    submitButton.type = 'submit';
    submitButton.innerHTML = '확인';

    submitWrapper.appendChild(submitButton);

    formContainer.addEventListener('submit', e => {
        e.preventDefault();
        const formData = new FormData(formContainer);
        const param = Object.fromEntries(formData);
        if (param.newPassword === param.confirmNewPassword) {
            resetPassword(param).then(res => {
                if (res.code === '400') {
                    currentPassword.classList.add('invalid');
                } else if (res.code === 0) {
                    logout().then(() => {
                        removeToken();
                        navigateTo(PATH_ADMIN_LOGIN);
                    });
                }
            });
        } else {
            confirmNewPassword.classList.add('invalid');
        }
    });

    const currentPassword = InputGroupWithErrMsg({
        id: 'currentPassword',
        name: 'currentPassword',
        required: true,
        label: '현재 비밀번호',
        inputType: 'password',
        placeholder: '현재 비밀번호를 입력해주세요.',
        defaultErrorMsg: '비밀번호가 올바르지 않습니다.',
        handleInput: e => {
            e.target.closest('.input-group').classList.remove('invalid');
        },
    });

    const newPassword = InputGroupWithErrMsg({
        id: 'newPassword',
        name: 'newPassword',
        required: true,
        label: '신규 비밀번호',
        inputType: 'password',
        placeholder: '신규 비밀번호를 입력해주세요.',
        inputAttr: { minLength: 8, maxLength: 20 },
        defaultErrorMsg: '비밀번호 형식에 맞지 않습니다.',
    });

    const confirmNewPassword = InputGroupWithErrMsg({
        id: 'confirmNewPassword',
        name: 'confirmNewPassword',
        required: true,
        label: '신규 비밀번호 확인',
        inputType: 'password',
        placeholder: '다시 한 번 입력해주세요.',
        inputAttr: { minLength: 8, maxLength: 20 },
        defaultErrorMsg: '비밀번호가 일치하지 않습니다.',
        handleInput: e => {
            e.target.closest('.input-group').classList.remove('invalid');
        },
    });

    formContainer.append(currentPassword, newPassword, confirmNewPassword, submitWrapper);

    managementContainer.append(titleContainer, formContainer);

    return managementContainer;
}

export default ChangePassword;
